export default {
    methods: {
        formatNumber: function(number, digits = 0) {
            if (number === null) {
                return this.$t("utils.novalue")
            }
            if (!number) {
                return "0"
            }
            var formatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: digits, minimumFractionDigits: digits });
            return formatter.format(number);
        },
        formatAmount: function(number) {
            return new Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 2 }).format(number || 0);
        },
        // Accepts both "2,5" and "2.5" (phone keyboards differ), returns NaN for invalid input
        parseAmount: function(value) {
            if (value === null || value === undefined || String(value).trim() === "") {
                return null;
            }
            return Number(String(value).replace(/\s/g, "").replace(",", "."));
        }
    }
}